import { render, staticRenderFns } from "./selection.vue?vue&type=template&id=3d1e72c3&scoped=true"
import script from "./selection.vue?vue&type=script&lang=js"
export * from "./selection.vue?vue&type=script&lang=js"
import style0 from "./selection.vue?vue&type=style&index=0&id=3d1e72c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1e72c3",
  null
  
)

export default component.exports